import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { initFN } from 'utils/init';
import { ThemeProvider } from 'styled-components';
import theme from 'style-utils/theme';
import App from 'App/App';
import { injectScript } from 'utils/functions/injectScript';
import { GRECAPTCHA_SCRIPT_URL } from 'utils/functions/grecaptcha';
import { injectUtagScripts } from 'utils/functions/injectUtagScripts';
import { injectVivochatScript } from 'utils/functions/injectVivochatScript';
import { injectOneTrustScript } from 'utils/functions/injectOneTrustScript';

const showErrorOverlay = (err: unknown) => {
  // must be within function call because that's when the element is defined for sure.

  const ErrorOverlay = customElements.get('vite-error-overlay');
  // don't open outside vite environment
  if (!ErrorOverlay || document.querySelector('vite-error-overlay')) {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(err);
  const overlay = new ErrorOverlay(err);
  document.body.appendChild(overlay);
};

window.addEventListener('error', showErrorOverlay);
window.addEventListener('unhandledrejection', ({ reason }) =>
  showErrorOverlay(reason),
);

function renderApplication(appRootDomId: string) {
  const root = ReactDOM.createRoot(
    document.getElementById(appRootDomId) as HTMLElement,
  );

  if (!root) {
    throw new Error(
      `I couldn't locate the app root with id \`${appRootDomId}\``,
    );
  }

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
  );
}

initFN()
  .then(() => {
    injectUtagScripts();
    injectScript(GRECAPTCHA_SCRIPT_URL);
    injectVivochatScript();
    injectOneTrustScript();
    renderApplication('root');
  })
  .catch(showErrorOverlay);

//TODO --> Aggiungere handler in caso di errore non gestito
